<script>
import TwContainer from '@/components/generic/tw-container.vue'
import TwCard from '@/components/generic/tw-card.vue'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
import { useFundraiserPublicStore } from '@/stores/fundraiserPublic.js'
import { useTeamPublicStore } from '@/stores/teamPublic.js'

export default {
  name: 'TeamRedirectOldPage',
  components: { TwLoadingSpinner, TwCard, TwContainer },
  props: {
    oldId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      Loading: true,
      NotFound: false,
    }
  },
  mounted() {
    this.redirectToTeam()
  },
  methods: {
    async redirectToTeam() {
      try {
        this.ValidationErrorMessage = null
        this.Loading = true
        const team = await useTeamPublicStore().fetchItemByOldId(this.oldId)
        console.log(team)

        this.Loading = false
        if(team) {
          this.$router.push({ name: 'FundraiserTeamPublicPage', params: { teamId: team.id, fundraiserId: team.fundraiser_id } })
        } else {
          this.NotFound = true
        }
      } catch (e) {
        this.NotFound = true
        console.error(e)
        this.Loading = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    }
  }
}
</script>

<template>
  <tw-container>
    <tw-card>
      <tw-loading-spinner v-if="Loading" />
      <div v-if="NotFound" class="text-center">
        <h1 class="text-2xl font-bold">
          Team not found
        </h1>
      </div>
    </tw-card>
  </tw-container>
</template>

<style scoped>

</style>
